<template>
<span>
    {{ value }}
</span>
</template>

<script>
export default {
    props: {
        multiply: {
            default: '1',
            type: String,
            _descr: 'value to multiply on',
        },
        decimals: {
            default: '0',
            type: String,
            _descr: 'number of decimals',
        },
    },
    computed: {
        fromParent () {
            let countCardsComponent = this.$parent;

            while (countCardsComponent !== undefined && countCardsComponent.purpose !== 'for-value-node') {
                countCardsComponent = countCardsComponent.$parent;
            }

            return countCardsComponent.value;
        },
        value () {
            if (!this.fromParent) {
                return '';
            }
            return parseFloat((this.fromParent * parseFloat(this.multiply)).toFixed(parseInt(this.decimals, 10)));
        },
    },
};
</script>
